import {blue, green, red} from '@ant-design/colors';
import {LabelObjType} from '@nxsys/types/models/apps/Contact';

const labelList: LabelObjType[] = [
  {id: 311, name: 'Nxsys', alias: 'nxsys', color: red[5]},
  {id: 312, name: 'Personal', alias: 'personal', color: blue[5]},
  {id: 313, name: 'Work', alias: 'work', color: green[5]},
];
export default labelList;
